export default __webpack_public_path__ + "static/media/icons8-discover-card.fdb99b69.svg";